import { ResourceOptions } from 'react-admin';
import { FaUndo } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingRedpacketBalanceReclaim;
export const icon = FaUndo;
export const options: ResourceOptions = {
  label: 'module.socialTrading.redpacketBalanceReclaim',
};
